export default __webpack_public_path__ + "static/macqLogo-4038d8dd5aa33ff72778806ebd10cb8e.png";